import * as React from "react"
import {Grid, Skeleton, Typography} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";
import {formatNumber, generateArrayByNumber, isEmpty} from "@ui-seeker/utils";

import {isLoadingCommonFilters} from "@signals";
import {numbersData} from "./@signals";


export default function MarketplacesNumbers() {
	if (isLoadingCommonFilters.value) return <Grid container spacing={2} sx={{ mt: 3 }}>
		{ generateArrayByNumber(3).map(idx => <Grid item key={idx} xs={4}>
			<Skeleton variant="rectangular" height={84} />
		</Grid>) }
	</Grid>

	if (isEmpty(numbersData.value)) return <></>

	return <Grid container spacing={2} sx={{ mt: 3 }}>
		{ ['Sellers', 'Products', 'Offers'].map(label => <Grid item xs={4} key={label}>
			<CardSeeker contentProps={{ sx: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } }}>
				<Typography variant="subtitle2">
					Number of {label.toLowerCase()}
				</Typography>
				<Typography variant="h4">
					{formatNumber(numbersData.value[`num${label}`], { decimals: 0})}
				</Typography>
			</CardSeeker>
		</Grid>) }
	</Grid>
}